import { IdentificationTypes } from 'src/enums/IdentificationTypes';

export const VERIFICATION_DOC_HEADER_KEYS = {
  [IdentificationTypes.RESIDENCE_PERMIT]: 'verificationList.residencePermit',
  [IdentificationTypes.IDENTITY_CARD]: 'verificationList.nationalId',
  [IdentificationTypes.PASSPORT]: 'verificationList.passport',
  [IdentificationTypes.DRIVER_LICENSE]: 'verificationList.drivingLicense',
};

export const getVerificationDocHeaderKey = (docType) =>
  VERIFICATION_DOC_HEADER_KEYS[docType];
